import React from "react";
import { HiLockClosed, HiOutlineXMark } from "react-icons/hi2";

export const Select = ({
  label,
  placeholder,
  type,
  onChange,
  value,
  name,
  disabled,
  options,
  className,
  onClear,
  showClear,
}) => {
  // value 0 / "0" corrisponde al placeholder ("Seleziona..."), quindi non e' un
  // dato da svuotare: la "x" appare solo quando c'e' una selezione reale.
  const showX = showClear && value && value != 0 && !disabled;

  const onPressClear = () => {
    if (onClear) {
      onClear();
    } else {
      onChange({ target: { name: name, value: "" } });
    }
  };

  return (
    <div className="relative mb-2">
      <label className="text-gray-500 text-xs font-medium uppercase tracking-wider px-1 left-2 -top-2">
        {label} {disabled ? <HiLockClosed className="inline" /> : ""}
      </label>
      <div className="relative">
        <select
          onChange={onChange}
          value={value || 0}
          disabled={disabled}
          className={
            (className || "") +
            ` rounded-md h-10 p-2 pl-2 w-full focus:outline-success-200 ${
              showX ? "pr-8" : ""
            } ${
              disabled
                ? "border-2 border-primary-300 active:border-primary-300 focus-visible::border-primary-300 focus:border-primary-300 bg-gray-100"
                : "border border-gray-300 focus:border-gray-300"
            }`
          }
        >
          <option value={0}>{placeholder}</option>
          {options.map((el) => (
            <option key={el.id} value={el.id} name={name}>
              {el.name}
            </option>
          ))}
        </select>
        {showX && (
          <button
            type="button"
            onClick={onPressClear}
            className="absolute right-6 top-1/2 z-10 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 focus:outline-none"
          >
            <HiOutlineXMark className="w-5 h-5" />
          </button>
        )}
      </div>
    </div>
  );
};

/* 
<Select
  label={"Motivo fine servizio"}
  placeholder="Seleziona..."
  options={[{ id: 1, name: "test 1" },{ id: 2, name: "test 2" },]}
  disabled={true}
/>
*/
